import clsx from "clsx";
import type { CSSProperties } from "react";
import s from "./Skeleton.module.css";

export function Skeleton({ width, height = 12, radius, className }: { width?: CSSProperties["width"]; height?: number; radius?: number; className?: string }) {
  return <span className={clsx(s.skeleton, className)} style={{ width, height, borderRadius: radius }} aria-hidden />;
}
